const GITHUB_PULL_REQUESTS_ANNOTATION = "github.com/project-slug";
const GITHUB_PULL_REQUESTS_TEAM_ANNOTATION = "github.com/team-slug";
const isGithubSlugSet = (entity) => {
  return entity?.metadata.annotations?.[GITHUB_PULL_REQUESTS_ANNOTATION] ?? "";
};
const isGithubTeamSlugSet = (entity) => {
  return entity?.metadata.annotations?.[GITHUB_PULL_REQUESTS_TEAM_ANNOTATION] ?? "";
};

export { GITHUB_PULL_REQUESTS_ANNOTATION, GITHUB_PULL_REQUESTS_TEAM_ANNOTATION, isGithubSlugSet, isGithubTeamSlugSet };
//# sourceMappingURL=isGithubSlugSet.esm.js.map
